import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Message } from 'semantic-ui-react';

interface OrganizationCurrencyWarningProps {
  /** Template path the builder validates. Its value is `false` while blocked. */
  path: string;
  /** Read by the template builder, not by this component. */
  validation?: Record<string, unknown>;
  configured?: boolean | null;
  currency?: string | null;
}

/**
 * Shown when the picked charity fundraises in a currency the event program has
 * no minimum fundraising target for. The builder reads `path` and `validation`
 * off this element to keep the save button disabled while that is the case.
 *
 * `negative` rather than `warning` or `error`: the template builder wraps the
 * tab in a `.ui.form`, and Semantic UI hides form-state messages inside a form
 * unless the form itself carries that state.
 */
export const OrganizationCurrencyWarning: React.FC<
  OrganizationCurrencyWarningProps
> = ({ configured, currency }) => {
  if (configured !== false) {
    return null;
  }

  return (
    <Message
      negative
      role="alert"
      content={I18n.t(
        'eventPrograms.template.page.setup.organization-currency-not-configured',
        { currency }
      )}
    />
  );
};

export default OrganizationCurrencyWarning;
